"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react/jsx-runtime"),
    t = require("react"),
    _r = function r() {
  return (_r = Object.assign || function (e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      for (var i in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
};

var n = "styles-module_blinkingCursor__288eE";
!function (e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;

  if (e && "undefined" != typeof document) {
    var n = document.head || document.getElementsByTagName("head")[0],
        i = document.createElement("style");
    i.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(i, n.firstChild) : n.appendChild(i), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e));
  }
}(".styles-module_blinkingCursor__288eE{position:relative;font:inherit;color:inherit;line-height:inherit;left:3px;top:0;-webkit-animation-name:styles-module_blink__dHnpo;animation-name:styles-module_blink__dHnpo;-webkit-animation-duration:.8s;animation-duration:.8s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;opacity:1}@-webkit-keyframes styles-module_blink__dHnpo{0%{opacity:1}to{opacity:0}}@keyframes styles-module_blink__dHnpo{0%{opacity:1}to{opacity:0}}");

var i = function i(t) {
  var i = t.cursorStyle,
      o = void 0 === i ? "|" : i;
  return e.jsx("span", _r({
    className: n
  }, {
    children: o
  }), void 0);
};

exports.Cursor = i, exports.Typewriter = function (r) {
  var n = r.words,
      o = void 0 === n ? ["Hello", "World", "This", "is", "Typewriter"] : n,
      u = r.loop,
      s = void 0 === u ? 1 : u,
      c = r.cursor,
      a = void 0 !== c && c,
      l = r.cursorStyle,
      d = void 0 === l ? "." : l,
      p = r.typeSpeed,
      f = void 0 === p ? 100 : p,
      v = r.delaySpeed,
      y = void 0 === v ? 1500 : v,
      m = r.deleteSpeed,
      h = void 0 === m ? 50 : m,
      g = r.onLoopDone,
      _ = t.useState(f),
      b = _[0],
      S = _[1],
      T = t.useState(""),
      k = T[0],
      x = T[1],
      w = t.useRef(0),
      C = t.useRef(0),
      j = t.useRef(!1),
      R = t.useRef(!1),
      E = t.useCallback(function () {
    S(f);
    var e = w.current % o.length,
        t = o[e];
    j.current ? (x(function (e) {
      return t.substring(0, e.length - 1);
    }), "" === k && (j.current = !1, S(h), w.current += 1)) : (x(function (e) {
      return t.substring(0, e.length + 1);
    }), k === t && (C.current += 1, j.current = !0, S(y), C.current / o.length === s && (R.current = !0, s > 0 && g && g())));
  }, [y, h, s, k, f, o, g]);

  return t.useEffect(function () {
    var e = setTimeout(function () {
      return E();
    }, b);
    return R.current && clearTimeout(e), function () {
      return clearTimeout(e);
    };
  }, [E, b]), e.jsxs(e.Fragment, {
    children: [e.jsx("span", {
      children: k
    }, void 0), a && e.jsx(i, {
      cursorStyle: d
    }, void 0)]
  }, void 0);
}, exports.useTypewriter = function (e) {
  var r = e.words,
      n = void 0 === r ? ["Hello", "World", "This", "is", "Typewriter"] : r,
      i = e.loop,
      o = void 0 === i ? 1 : i,
      u = e.typeSpeed,
      s = void 0 === u ? 20 : u,
      c = e.deleteSpeed,
      a = void 0 === c ? 50 : c,
      l = e.delaySpeed,
      d = void 0 === l ? 1500 : l,
      p = e.onLoopDone,
      f = t.useState(s),
      v = f[0],
      y = f[1],
      m = t.useState(""),
      h = m[0],
      g = m[1],
      _ = t.useRef(0),
      b = t.useRef(0),
      S = t.useRef(!1),
      T = t.useRef(!1),
      k = t.useCallback(function () {
    y(s);
    var e = _.current % n.length,
        t = n[e];
    S.current ? (g(function (e) {
      return t.substring(0, e.length - 1);
    }), "" === h && (S.current = !1, y(a), _.current += 1)) : (g(function (e) {
      return t.substring(0, e.length + 1);
    }), h === t && (b.current += 1, S.current = !0, y(d), b.current / n.length === o && (T.current = !0, o > 0 && p && p())));
  }, [d, a, o, h, s, n, p]);

  return t.useEffect(function () {
    var e = setTimeout(k, v);
    return T.current && clearTimeout(e), function () {
      return clearTimeout(e);
    };
  }, [k, v]), h;
};